// Central content + assets for Real Estate Pro (all copy in Dutch).

export const IMAGES = {
  // Property photography (copyright-safe, Unsplash/Pexels)
  villaHero: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NTYwNDU0MXww&ixlib=rb-4.1.0&q=85&w=1200",
  villaB: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NTYwNDU0MXww&ixlib=rb-4.1.0&q=85&w=900",
  villaPool: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NTYwNDU0MXww&ixlib=rb-4.1.0&q=85&w=900",
  villaModern: "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NTYwNDU0MXww&ixlib=rb-4.1.0&q=85&w=900",
  living1: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1NjA0NTQxfDA&ixlib=rb-4.1.0&q=85&w=900",
  living2: "https://images.unsplash.com/photo-1618220179428-22790b461013?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1NjA0NTQxfDA&ixlib=rb-4.1.0&q=85&w=900",
  living3: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxicmlnaHQlMjBtb2Rlcm4lMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1NjA0NTQxfDA&ixlib=rb-4.1.0&q=85&w=900",
  kitchen1: "https://images.unsplash.com/photo-1722605090433-41d1183a792d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8fHwxNzg1NjA0NTQwfDA&ixlib=rb-4.1.0&q=85&w=900",
  kitchen2: "https://images.unsplash.com/photo-1502005097973-6a7082348e28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwaW50ZXJpb3IlMjBkZXNpZ258ZW58MHx8fHwxNzg1NjA0NTQwfDA&ixlib=rb-4.1.0&q=85&w=900",
  agent: "https://images.unsplash.com/photo-1529922029839-049df7d315f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxyZWFsJTIwZXN0YXRlJTIwcHJvZmVzc2lvbmFsJTIwc21hcnRwaG9uZXxlbnwwfHx8fDE3ODU2MDQ0MDF8MA&ixlib=rb-4.1.0&q=85&w=900",
  social: "https://images.unsplash.com/photo-1730094485174-e543677a2a24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxzbWFydHBob25lJTIwZmlsbWluZyUyMG1vZGVybiUyMGhvdXNlJTIwcmVhbCUyMGVzdGF0ZXxlbnwwfHx8fDE3ODU3NzM3NjZ8MA&ixlib=rb-4.1.0&q=85&w=800",
  adsScreen: "https://images.unsplash.com/photo-1487014679447-9f8336841d58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxsYXB0b3AlMjBicm93c2VyfGVufDB8fHx8MTc4NTc3Mzc2Nnww&ixlib=rb-4.1.0&q=85&w=800",
  laptopSite: "https://images.unsplash.com/photo-1678690832311-bb6e361989ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjBicm93c2VyfGVufDB8fHx8MTc4NTc3Mzc2Nnww&ixlib=rb-4.1.0&q=85&w=800",
  tabletPresent: "https://images.unsplash.com/photo-1648737966100-18f790c93a86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxyZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBzaG93aW5nJTIwdGFibGV0JTIwdG8lMjBjb3VwbGV8ZW58MHx8fHwxNzg1NzczNzY2fDA&ixlib=rb-4.1.0&q=85&w=800",
  hillside: "https://images.pexels.com/photos/740587/pexels-photo-740587.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Photo set used inside the dashboard mockups
export const MOCKUP_PHOTOS = [
  IMAGES.villaHero,
  IMAGES.living1,
  IMAGES.kitchen1,
  IMAGES.living2,
  IMAGES.villaPool,
  IMAGES.kitchen2,
];

export const NAV_LINKS = [
  { label: "Zo werkt het", id: "zo-werkt-het" },
  { label: "Voor en na", id: "voor-en-na" },
  { label: "Toepassingen", id: "toepassingen" },
  { label: "Pakketten", id: "pakketten" },
  { label: "FAQ", id: "faq" },
];

export const AUDIENCES = [
  "Vastgoedmakelaars",
  "Vastgoedkantoren",
  "Vastgoedfotografen",
  "Projectontwikkelaars",
  "Vastgoedmarketingbureaus",
  "Vastgoedteams",
];

export const PACKAGES = [
  {
    id: "starter",
    name: "Starter",
    monthlyCredits: 4,
    audience: "Individuele makelaars en kleine kantoren",
    price: "€149",
    period: "per maand",
    monthlyOptions: "Tot 24 video-opties per maand",
    perProperty: "€37,25 per listing",
    value: null,
    highlight: null,
    features: [
      "4 listings per maand",
      "Tot 20 foto's per listing",
      "6 video-opties per listing",
      "Tot 24 video-opties per maand",
      "Tot 80 listingfoto's per maand",
      "Volledige video's downloaden",
      "Afzonderlijke clips downloaden",
      "Ongebruikte credits blijven behouden",
    ],
    cta: "Start met Starter",
    recommended: false,
    badge: null,
  },
  {
    id: "growth",
    name: "Growth",
    monthlyCredits: 10,
    audience: "Actieve makelaars en groeiende vastgoedkantoren",
    price: "€349",
    period: "per maand",
    monthlyOptions: "Tot 60 video-opties per maand",
    perProperty: "€34,90 per listing",
    value: "Beste combinatie van prijs en volume",
    highlight: "€2,35 voordeliger per listing dan Starter",
    features: [
      "10 listings per maand",
      "Tot 20 foto's per listing",
      "6 video-opties per listing",
      "Tot 60 video-opties per maand",
      "Tot 200 listingfoto's per maand",
      "Volledige video's downloaden",
      "Afzonderlijke clips downloaden",
      "Ongebruikte credits blijven behouden",
    ],
    cta: "Kies Growth",
    recommended: true,
    badge: "MEEST GEKOZEN",
  },
  {
    id: "pro",
    name: "Pro",
    monthlyCredits: 20,
    audience: "Grotere kantoren, teams en hogere volumes",
    price: "€649",
    period: "per maand",
    monthlyOptions: "Tot 120 video-opties per maand",
    perProperty: "€32,45 per listing",
    value: null,
    highlight: "€4,80 voordeliger per listing dan Starter",
    features: [
      "20 listings per maand",
      "Tot 20 foto's per listing",
      "6 video-opties per listing",
      "Tot 120 video-opties per maand",
      "Tot 400 listingfoto's per maand",
      "Volledige video's downloaden",
      "Afzonderlijke clips downloaden",
      "Ongebruikte credits blijven behouden",
    ],
    cta: "Start met Pro",
    recommended: false,
    badge: "LAAGSTE PRIJS PER LISTING",
  },
];

export const COMPARISON = {
  headers: ["Starter", "Growth", "Pro"],
  rows: [
    { label: "Prijs per maand (excl. btw)", values: ["€149", "€349", "€649"] },
    { label: "Listings per maand", values: ["4", "10", "20"] },
    { label: "Prijs per listing", values: ["€37,25", "€34,90", "€32,45"] },
    { label: "Foto's per listing", values: ["Tot 20", "Tot 20", "Tot 20"] },
    { label: "Video-opties per listing", values: ["6", "6", "6"] },
    { label: "Video-opties per maand", values: ["Tot 24", "Tot 60", "Tot 120"] },
    { label: "Listingfoto's per maand", values: ["Tot 80", "Tot 200", "Tot 400"] },
    { label: "Volledige video downloaden", values: ["Inbegrepen", "Inbegrepen", "Inbegrepen"] },
    { label: "Afzonderlijke clips downloaden", values: ["Inbegrepen", "Inbegrepen", "Inbegrepen"] },
    { label: "Ongebruikte credits behouden", values: ["Ja", "Ja", "Ja"] },
    {
      label: "Ideaal voor",
      values: [
        "Individuele makelaars en kleine kantoren",
        "Actieve makelaars en groeiende kantoren",
        "Grotere kantoren en teams",
      ],
    },
  ],
};

export const CREDIT_INFO = [
  {
    icon: "wallet",
    title: "Ongebruikte credits blijven behouden",
    text: "Gebruik je in een bepaalde maand niet alle listings uit je pakket? De resterende credits blijven beschikbaar op je account en vervallen niet automatisch aan het einde van de maand.",
  },
  {
    icon: "home",
    title: "Eén listing is één videoproject",
    text: "Voor iedere woning of vastgoedlisting waarvoor je een video genereert, wordt één projectcredit gebruikt.",
  },
  {
    icon: "film",
    title: "Zes video-opties per listing",
    text: "Voor iedere gegenereerde listing ontvang je zes verschillende complete video-opties. Kies de versie die het beste past bij de woning en het gebruikte kanaal.",
  },
  {
    icon: "download",
    title: "Volledige video's en losse clips",
    text: "Download een complete gegenereerde video of download de afzonderlijke videoclips om ze zelf verder te gebruiken.",
  },
  {
    icon: "dashboard",
    title: "Alles zichtbaar in je dashboard",
    text: "In je persoonlijke dashboard zie je hoeveel projectcredits beschikbaar zijn en hoeveel projecten je al hebt aangemaakt.",
  },
  {
    icon: "team",
    title: "Meer dan 20 listings nodig?",
    text: "Werk je met een groter volume, meerdere teams of verschillende kantoren? Dan bekijken we samen een oplossing die aansluit bij jouw organisatie.",
  },
];

export const BENEFITS = [
  { title: "Gebruik de foto's die je al hebt", text: "Creëer nieuwe videocontent zonder opnieuw langs te gaan bij het pand." },
  { title: "Geen montagekennis nodig", text: "De workflow is ontwikkeld om professionele vastgoedvideo toegankelijk en eenvoudig te maken." },
  { title: "Content voor verschillende kanalen", text: "Gebruik je video's voor social media, websites, advertenties en vastgoedpresentaties." },
  { title: "Consistente uitstraling", text: "Presenteer al je woningen in een herkenbare en professionele stijl." },
  { title: "Meer content per woning", text: "Haal meer marketingmateriaal uit iedere bestaande fotoset." },
  { title: "Ontwikkeld om mee te groeien", text: "Verwerk meerdere woningen zonder voor ieder pand een volledig nieuw productieproces te starten." },
];

export const USE_CASES = [
  { title: "Sociale media", label: "Verticale content", text: "Publiceer professionele vastgoedvideo's op Instagram, Facebook, TikTok en andere sociale kanalen.", img: "https://images.unsplash.com/photo-1613977257363-707ba9348227?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjB2aWxsYSUyMHdoaXRlJTIwZXh0ZXJpb3IlMjBzdW5ueSUyMGJsdWUlMjBza3l8ZW58MHx8fHwxNzg2NzA5NTAxfDA&ixlib=rb-4.1.0&q=85&w=800", alt: "Heldere moderne luxe villa met zwembad en blauwe lucht voor social media content" },
  { title: "Vastgoedadvertenties", label: "Meer visuele impact", text: "Gebruik dynamische videocontent om woningen sterker te presenteren binnen advertentiecampagnes.", img: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwbW9kZXJuJTIwcmVzaWRlbmNlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NTkzMTc2OXww&ixlib=rb-4.1.0&q=80&w=640", alt: "Hedendaagse woning met zwembad voor vastgoedadvertenties" },
  { title: "Website en vastgoedplatformen", label: "Professionele presentatie", text: "Voeg listingvideo's toe aan je website, online vastgoedpresentaties en relevante vastgoedplatformen.", img: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxoaWdoLWVuZCUyMHdoaXRlJTIwdmlsbGElMjBleHRlcmlvcnxlbnwwfHx8fDE3ODU5MzE3Njl8MA&ixlib=rb-4.1.0&q=80&w=640", alt: "Premium residentieel gebouw voor online vastgoedpresentaties" },
  { title: "Klantpresentaties", label: "Sterker in ieder gesprek", text: "Gebruik professionele listingvideo's in gesprekken met verkopers, kopers en samenwerkende partijen.", img: "https://images.unsplash.com/photo-1613977257592-4871e5fcd7c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxoaWdoLWVuZCUyMHdoaXRlJTIwdmlsbGElMjBleHRlcmlvcnxlbnwwfHx8fDE3ODU5MzE3Njl8MA&ixlib=rb-4.1.0&q=80&w=640", alt: "Moderne villa voor professionele klantpresentaties" },
];

export const VALUE_STACK = [
  "Eigen online dashboard",
  "Woningen en projecten beheren",
  "Vastgoedfoto's uploaden",
  "Foto's selecteren",
  "Beeldvolgorde aanpassen",
  "Videostijl kiezen",
  "Listingvideo genereren",
  "Video downloaden",
  "Content gebruiken binnen je vastgoedmarketing",
  "Maandelijks woningvolume opvolgen",
];

export const WHY = [
  { title: "Minder productiewerk", text: "Gebruik een duidelijke online workflow in plaats van voor iedere video vanaf nul te beginnen." },
  { title: "Meer consistente content", text: "Presenteer verschillende woningen met een herkenbare en professionele uitstraling." },
  { title: "Beter schaalbaar", text: "Kies een pakket dat aansluit bij het aantal woningen dat je iedere maand verwerkt." },
];

export const CREDIBILITY = [
  "Minder handmatig productiewerk",
  "Meer consistente vastgoedcontent",
  "Een duidelijke workflow voor meerdere woningen",
];

export const FEATURE_CHIPS = [
  "Vloeiende camerabewegingen",
  "Professionele overgangen",
  "Woninginformatie in beeld",
  "Content voor social media",
  "Video voor website en presentatie",
];

export const CONTACT_EMAIL = "realestatepro.be@gmail.com";

export const FAQS = [
  { q: "Hoe werkt Real Estate Pro?", a: "Maak een account aan, start een nieuw project, kies een verticaal of horizontaal formaat en upload tot 20 vastgoedfoto's. Real Estate Pro verwerkt de foto's automatisch en genereert daarna zes verschillende previewvideo's waaruit je kunt kiezen." },
  { q: "Heb ik nieuwe foto's of een videograaf nodig?", a: "Nee. Real Estate Pro werkt met de vastgoedfoto's die je al hebt. Je hebt dus geen extra fotoshoot, videograaf of montagekennis nodig." },
  { q: "Welke videoformaten kan ik maken?", a: "Je kunt kiezen tussen een verticale en horizontale video. Zo kun je het formaat kiezen dat het beste past bij de manier waarop je de vastgoedcontent wilt gebruiken." },
  { q: "Hoe lang duurt het om mijn video's te genereren?", a: "Het genereren duurt doorgaans ongeveer één tot drie minuten. De exacte verwerkingstijd kan variëren afhankelijk van het project en de technische belasting." },
  { q: "Wat krijg ik nadat mijn project is gegenereerd?", a: "Na de generatie krijg je zes verschillende previewvideo's. Je kunt volledige video's individueel downloaden en je kunt ook de afzonderlijke clips van de video's downloaden, zodat je de content flexibel kunt gebruiken." },
  { q: "Wat gebeurt er met ongebruikte credits?", a: "Ongebruikte betaalde projectcredits blijven op je account staan en vervallen niet zolang je account open blijft en Real Estate Pro de dienst blijft aanbieden. Wanneer je je abonnement opzegt, stopt de maandelijkse verlenging aan het einde van de betaalde periode, maar je reeds betaalde resterende credits blijven beschikbaar." },
  { q: "Heb je een vraag of heb je hulp nodig?", a: `Ons team helpt je graag verder. Stuur een e-mail naar ${CONTACT_EMAIL} of gebruik het contactformulier op de website.` },
];
